import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDetailSeconds',
    standalone: false
})
export class FormatCallDetailSecondsPipe implements PipeTransform {
   transform(seconds: number): string {
      return formatSecondsAsString(seconds);
   }
}

export function formatSecondsAsString(seconds: number, usePreciseSeconds = false) {
   if (seconds < 60) {
      return usePreciseSeconds ? `${seconds}s` : '<1m';
   } else if (seconds < 3600) {
      const rawMinutes = seconds / 60;
      const integerPart = Math.floor(rawMinutes);
      const decimalPart = rawMinutes - integerPart;
      const roundedMinutes =
         decimalPart !== 0.5 ? Math.round(rawMinutes) : integerPart % 2 === 0 ? integerPart : integerPart + 1;
      return `${roundedMinutes}m`;
   } else {
      const hours = Math.floor(seconds / 3600);
      const remainingMinutes = Math.floor((seconds % 3600) / 60);
      return `${hours}h ${remainingMinutes}m`;
   }
}
